import {baseStyleProps as $63d03c54ca5e4b88$export$fe9c6e915565b4e8, useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import "../icon_vars.css";
import $hca24$icon_vars_cssmjs from "../icon_vars_css.mjs";
import {useProvider as $71dfb0e0358a12de$export$693cdb10cec23617} from "../provider/Provider.mjs";
import {useSlotProps as $62024859ff9f1f8a$export$1e5c9e6e4e15efe3} from "../utils/Slots.mjs";
import {filterDOMProps as $hca24$filterDOMProps} from "react-aria/filterDOMProps";
import $hca24$react from "react";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






function $20f96c95fdf7a1d8$var$iconColorValue(value) {
    return `var(--spectrum-semantic-${value}-color-icon)`;
}
const $20f96c95fdf7a1d8$var$iconStyleProps = {
    ...(0, $63d03c54ca5e4b88$export$fe9c6e915565b4e8),
    color: [
        'color',
        $20f96c95fdf7a1d8$var$iconColorValue
    ]
};
function $20f96c95fdf7a1d8$export$f04a61298a47a40f(props) {
    props = (0, $62024859ff9f1f8a$export$1e5c9e6e4e15efe3)(props, 'icon');
    let { children: children, size: size, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(otherProps, $20f96c95fdf7a1d8$var$iconStyleProps);
    let provider;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        provider = (0, $71dfb0e0358a12de$export$693cdb10cec23617)();
    } catch  {
    // ignore
    }
    let scale = 'M';
    if (provider != null) scale = provider.scale === 'large' ? 'L' : 'M';
    if (!ariaHidden) ariaHidden = undefined;
    // Use user specified size, falling back to provider scale if size is undef
    let iconSize = size ? size : scale;
    return /*#__PURE__*/ (0, $hca24$react).cloneElement(children, {
        ...(0, $hca24$filterDOMProps)(otherProps),
        ...styleProps,
        focusable: 'false',
        'aria-label': ariaLabel,
        'aria-hidden': ariaLabel ? ariaHidden || undefined : true,
        role: 'img',
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($hca24$icon_vars_cssmjs))), children.props.className, 'spectrum-Icon', `spectrum-Icon--size${iconSize}`, styleProps.className)
    });
}


export {$20f96c95fdf7a1d8$export$f04a61298a47a40f as Icon};
//# sourceMappingURL=Icon.mjs.map
